<script setup></script>

<template>
  <div class="accords text-justify">
    <div class="heading1 !mb-2">
      About accords
      <hr class="gradientLine" />
    </div>
    <div class="grid-cols-1 grid k1:grid-cols-2 gap-8">
      <div>
        <p>
          Join the movement to advance Europe’s Quantum Future through the
          Accords Programme!
        </p>
        <br />
        <p>
          We invite you to contribute to the European Quantum Ecosystem by
          participating in the Accords Programme. This platform is dedicated to
          showcasing the pioneers who are shaping the future of quantum
          technology across Europe. Whether you're involved in research,
          education, part of a startup, or an established industry leader, your
          contributions are essential. Share your innovations, spark
          collaborations, and help us define the quantum landscape across Europe
        </p>
        <br />
        <p>
          Submit your accord today and become an European Quantum Contributor!
        </p>
      </div>
      <img
        src="/EQRC logo full black.svg"
        alt=""
        class="w-[510px] object-cover m-4"
      />
    </div>
    <div class="k1:flex-row flex flex-col-reverse gap-8 py-10">
      <div class="k1:w-[480px] w-full k1:h-[450px] h-full flex-shrink-0">
        <img
          src="/quantum-technology-website.jpeg"
          alt=""
          class="object-cover w-full h-full rounded-xl"
        />
      </div>
      <div class="flex flex-col justify-evenly">
        <h1 class="heading1 !mb-2 pb-8 nowrap-computer">Why Join the Accords Program</h1>
            <table class="text-center table-fixed ">
            <tr>
              <th class="border border-gray-400 p-3">Your benefits</th>
              <th class="border border-gray-400 p-3">Europe's Benefits</th>
            </tr>
              <td class="border border-gray-400 bg-[#d9d9d9] p-3">Gain recognition as a pioneer</td>
              <td class="border border-gray-400 bg-[#d9d9d9] p-3">Assemble best practices for ecosystem growth</td>
            <tr>
              <td class="border border-gray-400 bg-[#d9d9d9] p-3">Earn the distinguished Quantum Medal</td>
              <td class="border border-gray-400 bg-[#d9d9d9] p-3">Accelerate the adoption of quantum technology</td>
            </tr>
            <tr>
              <td class="border border-gray-400 bg-[#d9d9d9] p-3">Elevate your visibility and impact</td>
              <td class="border border-gray-400 bg-[#d9d9d9] p-3">Foster collaboration across sectors</td>
            </tr>
            <tr>
              <td class="border border-gray-400 bg-[#d9d9d9] p-3">Shape the European Quantum Ecosystem</td>
              <td class="border border-gray-400 bg-[#d9d9d9] p-3">Strengthen Europe's global leadership in quantum technology</td>
            </tr>
          </table>      
        </div>
      </div>
    <div class="heading1 !mb-2 pb-4">
      Achieve Quantum Readiness
    </div>
    <div class="grid-cols-1 grid k1:grid-cols-2 gap-8 pb-10">
      <div class="self-center">
        <ul class="list-disc pl-5">
          <li>By submitting your accord, you contribute directly to creating a roadmap for the quantum future.</li>
          <br  />
          <li>Showcase your commitment to innovation with our Quantum Medal, a symbol of excellence for your website and communications.</li>
        </ul>
      </div>
      <img
        src="/quantum medal.png"
        alt=""
        class="rounded-xl w-[510px] object-cover"
      />
    </div>
    <div class="heading1 !mb-2 pb-4 nowrap-computer">
      Principles of the Quantum Readiness Initiative 
    </div>
    <p>
      The Accords are guided by foundational principles that build a healthy European quantum ecosystem. These principles focus on making quantum technologies:
    </p>
    <br />
    <ul class="list-disc pb-4 pl-4">
      <li>Accessible: Enabling widespread understanding and adoption.</li>
      <li>Understandable: Simplifying complex technologies for diverse stakeholders.</li>
      <li>Beneficial: Ensuring broad societal and economic impact.</li>
    </ul>
    <div class="heading1 !mb-2 pb-4">
      Shape the Future with Us 
    </div>
    <p>
      Ready to contribute? Embrace these principles and take action to help Europe lead the way in quantum innovation.<br>
      Click <RouterLink to="submitAccord" class="text-blue-500 underline hover:bg-blue-100">'Learn More'</RouterLink> to see how easy it is to join the movement!
    </p>
  </div>
</template>

<style scoped>
@media (min-width: 1024px) {
 .nowrap-computer {
  white-space: nowrap;
  }
}
</style>
